import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { createSelector, select, Store } from '@ngrx/store';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-i';
import { OrderBuilderState } from '../../../../../reducers';
import { AddedValueFieldConfig } from '../../../models/form-added-value-field-config';
import { getRmsRehydrate } from '../../../selectors';
import { getAddedValuesOpenPlatformState } from '../../../selectors/added-value.selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

const addedValueAndRehydrate = createSelector(getAddedValuesOpenPlatformState, getRmsRehydrate, (state, rehydate) => {
  return {
    state,
    rehydate,
  };
});

/**
 * Loads the added values as RMX_LEGACY
 * but using the open platform state
 */

@Injectable()
export class AdddedValuesLoaderRMXULService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  loadOptions(formGroup: UntypedFormGroup, config: AddedValueFieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(addedValueAndRehydrate),
      filter(({ state }) => {
        const selectedContract =
          formGroup.get(SpecFieldNames.CONTRACT_SELECT) && formGroup.get(SpecFieldNames.CONTRACT_SELECT).value;
        const formId = formGroup.get(SpecFieldNames.ID).value;
        const keyName = `${selectedContract}_${formId}`;
        return !!state.availableAddedValues[keyName];
      }),
      map(({ state }) => {
        const selectedContract =
          formGroup.get(SpecFieldNames.CONTRACT_SELECT) && formGroup.get(SpecFieldNames.CONTRACT_SELECT).value;
        const formId = formGroup.get(SpecFieldNames.ID).value;
        const keyName = `${selectedContract}_${formId}`;
        const availableAddedValues = state.availableAddedValues[keyName];
        return this.getAddedValuesToShow(availableAddedValues, config.index);
      }),
    );
  }

  /**
   * Returns them as combobox options
   * @param tuples
   * @param index
   */
  private getAddedValuesToShow(tuples: any[], index: number): SelectOptionI[] {
    if (tuples[index] && tuples[index].addedValues) {
      // options is all vaps available
      return tuples[index].addedValues.map((addedValue) => {
        return {
          id: addedValue.valueAddedCode,
          name: addedValue.valueAddedDesc,
        };
      });
    } else {
      return [];
    }
  }
}
